import { PosProductAPI } from '@/clients/location/pos.product.api'
export default {
    namespaced: true,
    state: {
        list: []
    },
    getters: {
        list: state => state.list
    },
    mutations: {
        mutateList(state, data) {
            state.list = data
        },
        clearLocationPosProductState(state) {
            Object.assign(state, require('./reset/location_pos_product.json'))
        }
    },
    actions: {
        async setList(context, locationId) {
            const { data: { payload } } = await PosProductAPI.fetch(locationId)
            context.commit('mutateList', payload)
        }
    }
}
